<div class="w-100 h-100 d-flex justify-content-center align-items-center">
  <ng-content></ng-content>
</div>
